var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-box"},[_c('h3',[_vm._v("An error occurred fetching this chart")]),_c('v-icon',{attrs:{"x-large":""}},[_vm._v("sentiment_dissatisfied")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }